import { ParamMap, Params } from '@angular/router';
import { ITown } from 'src/app/models';
import { parseIdList, serializeIdList } from './filterUtils';

export interface IServicesFilters {
  selectedTowns: ITown[];
}

export const SERVICE_FILTER_KEYS = ['towns'] as const;

export function serializeServicesFilters(f: IServicesFilters): Params {
  return {
    towns: serializeIdList(f.selectedTowns),
  };
}

export function deserializeServicesFilters(params: ParamMap, fallback?: ITown[]): IServicesFilters {
  return {
    selectedTowns: parseIdList<ITown>(params.get('towns'), fallback),
  };
}

export function parseServicesTownsFromStorage(json: string | null | undefined): ITown[] {
  if (!json) return [];
  try {
    const v = JSON.parse(json);
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
}
